import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/lib/react-router';
import { rest } from '@/lib/hono-client';
import LoginPage from '@/features/auth/LoginPage';
import RegisterPage from '@/features/auth/RegisterPage';

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',

  loader: async () => {
    const res = await rest.api.auth.users.$get();
    console.debug('LoginPage loader:', res);
    return res;
  },

  component: LoginPage,
});

const registerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/register',

  loader: async () => {
    // const res = await rest.api.auth.users.$get();
    // console.debug('RegisterPage loader:', res);
    // return res;
  },

  component: RegisterPage,
});

export const authRoutes = [loginRoute, registerRoute];
